export default "<div>\n    <app-master-plugin></app-master-plugin>\n</div>\n"